import * as api from '../api'

import type { NotificationConfiguration, Licence } from '../types/domain'
import { NotificationType } from '../types/model'
import texts from './texts'

const getPremiumNotification = (
  customerName: string,
): NotificationConfiguration => ({
  name: NotificationType.PREMIUM_ARTICLE,
  config: {
    message: texts.bannerPremiumArticle(customerName),
  },
})

const getUserOnboardingNotification = async (
  isArticle: boolean,
): Promise<NotificationConfiguration | undefined> => {
  const userNotification = await api.getUserOneTimeNotification({
    isArticle,
  })
  return userNotification === null ? undefined : userNotification
}

const getUserNotification = async (
  isArticle: boolean,
  isPremiumArticle: boolean,
  licence: Licence,
): Promise<NotificationConfiguration | undefined> =>
  isPremiumArticle
    ? licence.configuration?.popup?.brandAttribution.enabled !== false
      ? getPremiumNotification(licence.customer.name)
      : undefined
    : await getUserOnboardingNotification(isArticle)

export default getUserNotification
